<template>
  <nav>
    <!--<router-link to="/login">
      <a id="wt-header-brand-logo" href="#">
        <img src="@/assets/logo.png" width="171" height="52" />
      </a>
    </router-link>-->
    <router-link :to="{name: 'system-menu'}" id="wt-header-brand-logo">
      <picture v-if="activeSystem!='BPM'">
        <source srcset="@/assets/logo.png" media="(min-width: 1090px)" />
        <img src="@/assets/logo-fit.png" height="52" alt="logo" />
      </picture>
      <img src="@/assets/logo.png" height="52" alt="logo" v-if="activeSystem=='BPM'" />
    </router-link>
  </nav>
</template>
<script>
export default {
  name: "wt-header-brand",
  components: {},
  props: {},
  computed: {
    typeLayout() {
      return this.$store.state.layout.typeLayout;
    },
    activeSystem() {
      return this.$store.state.activeSystem;
    }
  },
  data: function() {
    return {};
  },
  methods: {}
};
</script>
